export default __webpack_public_path__ + "static/media/3.a5ba4974.mp3";